import { updateMerchantAddressPayload } from "@/models/payload/profile";
import profileService from "@/services/merchant";
import { useMutation } from "@tanstack/react-query";

function useUpdateMerchantAddress() {
  const {
    mutate: updateMerchant,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: updateMerchantAddressPayload) => {
      return profileService.updateMerchantAddress(command);
    },
  });
  return { updateMerchant, isLoading, isSuccess };
}

export default useUpdateMerchantAddress;
